<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        width="18"
        height="18"
        viewBox="0 0 14 14"
        name="kebab-menu"
      />
    </div>
    <aha-context-menu
      :ref="`context-menu-folder-${folder.folderId}`"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <aha-context-menu-header>
        {{ folder.folderName }}
      </aha-context-menu-header>
      <aha-context-menu-item
        v-if="showRenameFolderItem"
        @click="handleRenameFolderItemClick()"
      >
        <aha-svg class="text-base-70" name="edit" />
        <span>{{ $i18nPresenter.t("Rename") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        v-if="showEditTeamFolderItem"
        @click="handleEditFolderItemClick()"
      >
        <aha-svg class="text-base-70" name="edit" />
        <span>{{ $i18nPresenter.t("Rename") }}</span>
      </aha-context-menu-item>
      <aha-context-menu-item
        @click="handleDeleteFolderItemClick()"
        class="text-red-100"
      >
        <aha-svg name="delete" />
        <span>{{ $i18nPresenter.t("Delete") }}</span>
      </aha-context-menu-item>
    </aha-context-menu>

    <modal-delete-folder
      :folder="folder"
      v-if="isShowingDeleteFolderModal"
      @hide="handleHideDeleteFolderModal()"
    />
    <modal-delete-team-folder
      :folder="folder"
      v-if="isShowingDeleteTeamFolderModal"
      @hide="handleHideDeleteTeamFolderModal()"
    />
    <modal-rename-folder
      :folder="folder"
      v-if="isShowingRenameFolderModal"
      @hide="handleHideRenameFolderModal()"
    />
    <modal-update-team-folder
      v-if="isShowingEditTeamFolderModal"
      :folder="folder"
      @hide="handleHideEditFolderItemClick()"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
// utils
import utils from '@/util'

// constants
import constants from '@/constant'
import EventBus from '@/eventBus'

// modals
import ModalDeleteFolder from '../../modals/DeleteFolder.vue'
import ModalDeleteTeamFolder from '../../modals/DeleteTeamFolder.vue'
import ModalRenameFolder from '../../modals/RenameFolder.vue'
import ModalUpdateTeamFolder from '../../modals/UpdateTeamFolder.vue'

const { eventCategories } = constants

export default {
  components: {
    ModalDeleteFolder,
    ModalDeleteTeamFolder,
    ModalRenameFolder,
    ModalUpdateTeamFolder,
  },
  props: {
    folder: {
      type: Object,
      default: () => {},
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
    rightClickEnabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isShowingEditTeamFolderModal: false,
      isShowingRenameFolderModal: false,
      isShowingDeleteFolderModal: false,
      isShowingDeleteTeamFolderModal: false,
      targetX: null,
      targetY: null,
    }
  },
  computed: {
    ...mapState({
      currentFolderDepth: (state) => state.currentFolderDepth,
    }),
    showRenameFolderItem() {
      return this.$route.name !== 'Team'
    },
    showEditTeamFolderItem() {
      return this.$route.name === 'Team'
    },
  },
  mounted() {
    if (this.rightClickEnabled) {
      EventBus.$on(`open-kebab-folder-${this.folder.folderId}`, ({ id, x, y }) => {
        if (id !== this.folder.folderId) {
          return
        }

        this.targetX = x
        this.targetY = y
        this.handleIconClick(true)
      })
    }
  },
  destroyed() {
    EventBus.$off(`open-kebab-folder-${this.folder.folderId}`)
  },
  methods: {
    handleDeleteFolderItemClick() {
      if (this.$route.name === 'Team') {
        this.isShowingDeleteTeamFolderModal = true
        utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Team Folder > Open modal', null, null, {
          isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
          isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
          role: this.$store.state.currentUser.accountRole || null,
          teamId: this.$store.state.currentAccount.id || null,
          folderId: this.folder.folderId,
        })
      } else {
        this.isShowingDeleteFolderModal = true
        utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Open modal', null, null, {
          parentFolderId: this.selectedFolderId,
          folderDepth: this.currentFolderDepth || 0,
        })
      }
    },
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }

      this.isShowingRenameFolderModal = false
      this.$refs[`context-menu-folder-${this.folder.folderId}`].show()
      utils.mixpanelTracking(
        eventCategories.PRESENTATION_LIST,
        'Folder Kebab Menu > Open',
        null,
        null,
        {
          trigger: exact ? 'contextmenu' : 'click',
        },
      )
    },
    handleHideDeleteFolderModal() {
      this.isShowingDeleteFolderModal = false
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Close modal', null, null, {
        parentFolderId: this.selectedFolderId,
        folderDepth: this.currentFolderDepth || 0,
      })
    },
    handleHideDeleteTeamFolderModal() {
      this.isShowingDeleteTeamFolderModal = false
    },
    handleHideRenameFolderModal() {
      this.isShowingRenameFolderModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Close modal')
    },
    handleHideEditFolderItemClick() {
      this.isShowingEditTeamFolderModal = false
      utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Edit Folder > Close modal')
    },
    handleRenameFolderItemClick() {
      this.isShowingRenameFolderModal = true
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Open modal', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: this.folder.folderId || null,
      })
    },
    handleEditFolderItemClick() {
      this.isShowingEditTeamFolderModal = true
      utils.mixpanelTracking(constants.eventCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Edit Folder > Open modal', null, null, {
        isTeamFolder: this.$store.state.workingMode === constants.workspace.TEAM,
        isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        role: this.$store.state.currentUser.accountRole || null,
        teamId: this.$store.state.currentAccount.id || null,
        folderId: this.folder.folderId,
      })
    },
  },
}
</script>
